import React, { Component } from 'react';
import { isEmpty, isFinite, isNil } from 'lodash';
import { RESOURCE_TYPE_SCHEMA_SPECS } from '../../constants/resourceTypes';
import NoContentTextView from '../elements/NoContentTextView';
import AclTabViewContainer from '../elements/aclView/AclTabViewContainer';
import SchemaSpecOverviewTabContainer from './cards/SchemaSpecOverviewTabContainer';

import { SUPPORT_KEY_SCHEMA_SPEC } from '../../constants/supportPageKeys';
import { SearchFilterTypes, SearchFilterViews } from '../../constants/visibilityFilters';
import { CONTACT_SUPPORT_LINK } from '../../constants/config';
import { ACL_RESOURCE_TYPE_SCHEMA_TEMPLATE } from '../../constants/aclConstants';
import { shouldRefetchForAclMode } from '../../lib/ACLUtils';
import SchemaSpecsTable from 'js/components/schemaSpecs/SchemaSpecsTable';
import { BannerDescription } from 'new/elements/BannerDescription';
import { ResourceActivity } from 'new/elements/support/detailTabs/ResourceActivity';

const availableFilterTypes = [
  SearchFilterTypes.ID,
  SearchFilterTypes.NAME,
  SearchFilterTypes.DESCRIPTION,
  SearchFilterTypes.TAG,
];

const styles = {
  titleRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // marginTop: 16,
    backgroundColor: 'hsl(202,87%,12%)',
    // boxShadow: 'rgba(42, 63, 86, 0.1) 0px 0px 10px 0px',
    paddingTop: 14,
    paddingBottom: 14,
    margin: 0,
    position: 'sticky',
    top: 0,
    zIndex: 2,
    borderRadius: 0,
  },
  textArea: {
    display: 'flex',
    flexDirection: 'column',
  },
  heading: {
    paddingLeft: 20,
    marginBottom: 0,
    marginTop: 0,
    fontSize: 20,
    color: '#ff7436',
  },
  subheading: {
    fontSize: 12,
    paddingLeft: 20,
    color: '#cccccc',
  },
  headingCTA: {
    marginRight: 24,
    flexGrow: 0,
    flexShrink: 0,
    marginLeft: 12,
  },
};

const detailViewTabs = [
  {
    tabName: 'Overview',
    tabElement: <SchemaSpecOverviewTabContainer />,
  },
  {
    tabName: 'Activity',
    tabElement: <ResourceActivity resourceType={RESOURCE_TYPE_SCHEMA_SPECS} />,
  },
  {
    tabName: 'Share',
    tabElement: <AclTabViewContainer resourceType={ACL_RESOURCE_TYPE_SCHEMA_TEMPLATE} />,
  },
];

class ViewSchemaSpecs extends Component {
  componentDidMount() {
    this.props.setContextualSupport(SUPPORT_KEY_SCHEMA_SPEC);
  }

  componentWillUnmount() {
    this.props.unsetContextualSupport(SUPPORT_KEY_SCHEMA_SPEC);
  }

  _handleEditTxClicked = (tx) => {
    const { onFormLoadButtonClicked } = this.props;
    onFormLoadButtonClicked(tx);
  };

  _handleCreateTxClicked = () => {
    this.props.onFormLoadButtonClicked();
  };

  render() {
    const { isLoading, schemaSpecId, data, getSchemaSpecsListing, getSourceMeta, filters } =
      this.props;

    const singleItemMode = isFinite(schemaSpecId);
    let noContentView = null;
    if (isLoading === false && isEmpty(data)) {
      if (singleItemMode) {
        noContentView = (
          <NoContentTextView
            title={<div>We are sorry, we could not find this schema.</div>}
            subtitle={
              <div>
                Please reload the page or file a{' '}
                <a style={{ color: '#507fe7' }} href={CONTACT_SUPPORT_LINK}>
                  support ticket
                </a>{' '}
                to request support.
              </div>
            }
          />
        );
      } else {
        noContentView = (
          <NoContentTextView
            title={<div>Add your first schema spec! Click on the button above to get started.</div>}
          />
        );
      }
    }

    return (
      <>
        <BannerDescription
          title="Schema Templates"
          description="Ensure compliance with Nexset schema specifications when creating Nexsets. Create or edit Schema Templates with samples here, and utilize them for Nexset creation."
          onClick={singleItemMode ? undefined : this._handleCreateTxClicked}
          actionTitle="New Schema Template"
        />
        <SchemaSpecsTable
          view={SearchFilterViews.SCHEMA_SPECS}
          urlId={schemaSpecId}
          isLoading={isLoading}
          data={data}
          filters={filters}
          detailViewTabs={detailViewTabs}
          loadData={getSchemaSpecsListing}
          getSourceMeta={getSourceMeta}
          availableFilterTypes={availableFilterTypes}
          onAclQueryModeChanged={this._handleAclQueryModeChanged}
          onEditButtonClicked={this._handleEditTxClicked}
          noContentView={noContentView}
        />
      </>
    );
  }
}

export default ViewSchemaSpecs;
